const computeWidth = (width) => {
  let flex = '1'
  const validNumber = isValidNumber(width)
  if (/(%|px)$/.test(width) && validNumber) {
    flex = `0 0 ${width}`
  } else if (!isNaN(width)) {
    flex = `0 0 ${width}px`
  }
  return flex
}

const isValidNumber = (value) => !isNaN(parseFloat(value))

const addUnitForValue = (value, unit = 'px') => (!isNaN(value) ? `${value}${unit}` : value)

export { computeWidth, isValidNumber, addUnitForValue }
